module.exports = __webpack_public_path__ + "img/MAGADAN.eeac658e.png";